<template>
  <div>
    <v-btn @click="openDialog" color="pink" class="white--text"
      >Item Transfers
      <v-badge
        v-if="pendingConfirmations.length"
        color="orange"
        :content="pendingConfirmations.length"
        inline
        class="ml-1"
      ></v-badge>
    </v-btn>
    <v-dialog v-model="dialog" persistent width="1400">
      <v-card>
        <v-card-title>Item Transfer Modal</v-card-title>
        <v-card-text>
          <v-tabs v-model="activeTab">
            <v-tab>All Items</v-tab>
            <v-tab>Transfer History</v-tab>
            <v-tab>
              Pending Confirmation
              <v-badge
                v-if="pendingConfirmations.length"
                color="orange"
                :content="pendingConfirmations.length"
                inline
                class="ml-1"
              ></v-badge>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <!-- All Items Tab -->
            <v-tab-item>
              <div class="d-flex align-center mt-4">
                <v-text-field
                  label="Search items..."
                  v-model="search"
                  prepend-icon="mdi-magnify"
                ></v-text-field>
                <v-btn color="primary" class="ml-3" @click="openSerialScan">
                  <v-icon left>mdi-barcode-scan</v-icon>
                  Scan Serial
                </v-btn>
              </div>
              <h3>All Items Table</h3>
              <v-data-table
                dense
                :search="search"
                :items="items"
                :headers="item_headers"
              >
                <template v-slot:item.action="{ item }">
                  <v-btn icon @click="open_item_transfer(item)" color="blue"
                    ><v-icon>mdi-swap-horizontal</v-icon></v-btn
                  >
                </template>
                <template v-slot:item.item_name="{ item }">
                  <span
                    :class="
                      item.is_vat
                        ? 'green--text font-weight-bold'
                        : 'orange--text font-weight-bold'
                    "
                    >{{ item.item_name }}</span
                  >
                </template>
                <template v-slot:item.is_deleted="{ item }">
                  <span v-if="item.is_deleted" class="red--text">Deleted</span>
                  <span v-else class="green--text">Active</span>
                </template>
              </v-data-table>
              <!-- 
              <h3 class="mt-4">Active Transfers</h3>
              <v-text-field
                label="Search transfers..."
                v-model="search2"
                prepend-icon="mdi-magnify"
              ></v-text-field>
              <v-data-table
                dense
                :search="search2"
                :items="item_transfers"
                :headers="item_transfer_headers"
              >
                <template v-slot:item.action="{ item }">
                  <v-btn
                    color="red"
                    @click="confirmRevert(item)"
                    icon
                    :loading="revertingId === item.id"
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                </template>
                <template v-slot:item.amount="{ item }">
                  {{ formatCurrency(item.item.unit_price * item.quantity) }}
                </template>
              </v-data-table> -->
            </v-tab-item>

            <!-- Transfer History Tab -->
            <v-tab-item>
              <h3 class="mt-4">Transfer History</h3>
              <v-text-field
                label="Search history..."
                v-model="historySearch"
                prepend-icon="mdi-magnify"
              ></v-text-field>
              <v-data-table
                dense
                :search="historySearch"
                :items="transferHistory"
                :headers="history_headers"
                :loading="historyLoading"
              >
                <template v-slot:item.status="{ item }">
                  <v-chip
                    :color="item.is_reverted ? 'red' : 'green'"
                    small
                    dark
                  >
                    {{ item.is_reverted ? "Reverted" : "Active" }}
                  </v-chip>
                </template>
                <template v-slot:item.amount="{ item }">
                  {{
                    formatCurrency(
                      item.item ? item.item.unit_price * item.quantity : 0
                    )
                  }}
                </template>
                <template v-slot:item.confirmation="{ item }">
                  <v-chip
                    v-if="item.confirmed_received_at"
                    color="green"
                    small
                    dark
                  >
                    Received{{
                      item.confirmed_by_user
                        ? " by " + item.confirmed_by_user.full_name
                        : ""
                    }}
                    {{ formatDate(item.confirmed_received_at) }}
                  </v-chip>
                  <v-chip
                    v-else-if="!item.is_reverted"
                    color="orange"
                    small
                    dark
                  >
                    Pending
                  </v-chip>
                  <span v-else class="grey--text">-</span>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    v-if="canConfirm(item)"
                    color="green"
                    @click="confirmReceived(item)"
                    icon
                    :loading="confirmingId === item.id"
                    ><v-icon>mdi-check</v-icon></v-btn
                  >
                  <v-btn
                    v-if="!item.is_reverted"
                    color="red"
                    @click="confirmRevert(item)"
                    icon
                    :loading="revertingId === item.id"
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                  <span v-else class="grey--text">-</span>
                </template>
              </v-data-table>
            </v-tab-item>

            <!-- Pending Confirmation Tab -->
            <v-tab-item>
              <h3 class="mt-4">
                Pending Confirmation (incoming to your branch)
              </h3>
              <v-data-table
                dense
                :items="pendingConfirmations"
                :headers="pending_headers"
              >
                <template v-slot:item.amount="{ item }">
                  {{
                    formatCurrency(
                      item.item ? item.item.unit_price * item.quantity : 0
                    )
                  }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-btn
                    color="green"
                    small
                    dark
                    @click="confirmReceived(item)"
                    :loading="confirmingId === item.id"
                    >Confirm Received</v-btn
                  >
                </template>
                <template v-slot:no-data>
                  No incoming transfers waiting for confirmation.
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false"> Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text">itemTransferModal.vue</p>
        </v-card-actions>
      </v-card>
      <!-- lazy loaded components -->

      <item-transfer-modal-2
        :item="selected_item"
        :scanned-serials="transfer_scanned_serials"
        v-if="show_item_transfer_modal"
        @close="onTransferModalClose"
      />

      <!-- SCAN-BY-SERIAL DIALOG (same pattern as addReturnItemModal.vue, JMB-242) -->
      <v-dialog
        v-model="serial_scan_dialog"
        max-width="520"
        @keydown.esc="serial_scan_dialog = false"
      >
        <v-card>
          <v-card-title>
            <v-icon left color="primary">mdi-barcode-scan</v-icon>
            Scan Serial to Transfer Item
            <v-spacer></v-spacer>
            <v-btn icon @click="serial_scan_dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="serial_scan_input"
              ref="serialScanField"
              label="Scan or type a serial number"
              placeholder="Scan here, then press Enter"
              prepend-inner-icon="mdi-barcode-scan"
              outlined
              dense
              clearable
              autofocus
              hide-details
              :loading="serial_scan_loading"
              @keyup.enter="scanSerialToTransfer"
            ></v-text-field>
            <div
              v-if="serial_scan_feedback"
              class="caption mt-2"
              :class="
                serial_scan_feedback_type === 'success'
                  ? 'green--text'
                  : 'red--text'
              "
            >
              <v-icon
                x-small
                :color="
                  serial_scan_feedback_type === 'success' ? 'green' : 'red'
                "
                >{{
                  serial_scan_feedback_type === "success"
                    ? "mdi-check-circle"
                    : "mdi-alert-circle"
                }}</v-icon
              >
              {{ serial_scan_feedback }}
            </div>

            <!-- Scanned serials queued for this transfer -->
            <div v-if="scanned_serials.length" class="mt-4">
              <div class="font-weight-medium mb-1">
                {{ scanned_item ? scanned_item.item_name : "" }}
                <span class="grey--text"
                  >— {{ scanned_serials.length }} serial(s) to transfer</span
                >
              </div>
              <v-chip
                v-for="(s, i) in scanned_serials"
                :key="s.serial_number"
                class="ma-1"
                close
                small
                color="primary"
                outlined
                @click:close="removeScannedSerial(i)"
              >
                <v-icon x-small left>mdi-barcode</v-icon>
                {{ s.serial_number }}
                <span v-if="s.batch_description" class="grey--text ml-1"
                  >({{ s.batch_description }})</span
                >
              </v-chip>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="closeSerialScan">Close</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!scanned_serials.length"
              @click="transferScannedSerials"
            >
              <v-icon left>mdi-swap-horizontal</v-icon>
              Transfer {{ scanned_serials.length || "" }} Serial(s)
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  components: { itemTransferModal2: () => import("./itemTransferModal2.vue") },
  props: ["item"],
  data() {
    return {
      activeTab: 0,
      selected_item: "",
      show_item_transfer_modal: false,
      search: "",
      search2: "",
      historySearch: "",
      dialog: false,
      loading: false,
      historyLoading: false,
      revertingId: null,
      confirmingId: null,
      transferHistory: [],
      // Scan-by-serial lookup
      serial_scan_dialog: false,
      serial_scan_input: "",
      serial_scan_loading: false,
      serial_scan_feedback: "",
      serial_scan_feedback_type: "success",
      // Serials accumulated in the scan dialog + the item they belong to
      scanned_serials: [],
      scanned_item: null,
      // Serials handed to the transfer form when launched from a scan
      transfer_scanned_serials: [],
      item_headers: [
        { text: "", value: "action", width: "30" },
        { text: "ID", value: "id" },
        { text: "Item Name", value: "item_name" },
        { text: "Batch", value: "import_batch.batch_description" },
        { text: "Branch", value: "branch.branch_name" },
        { text: "Quantity", value: "quantity" },
        { text: "Is deleted", value: "is_deleted" },
      ],
      item_transfer_headers: [
        { text: "Action", value: "action" },
        { text: "ID", value: "id" },
        { text: "Item Name", value: "item.item_name" },
        { text: "Quantity", value: "quantity" },
        { text: "Amount", value: "amount" },
        { text: "Transferred By", value: "user.full_name" },
        { text: "From Branch", value: "from_branch" },
        { text: "To Branch", value: "to_branch" },
        { text: "Transfer Date", value: "transfer_date" },
        { text: "Notes", value: "notes" },
      ],
      history_headers: [
        { text: "Action", value: "action" },
        { text: "ID", value: "id" },
        { text: "Item Name", value: "item.item_name" },
        { text: "Quantity", value: "quantity" },
        { text: "Amount", value: "amount" },
        { text: "Transferred By", value: "user.full_name" },
        { text: "From Branch", value: "from_branch" },
        { text: "To Branch", value: "to_branch" },
        { text: "Transfer Date", value: "transfer_date" },
        { text: "Notes", value: "notes" },
        { text: "Status", value: "status" },
        { text: "Confirmation", value: "confirmation" },
      ],
      pending_headers: [
        { text: "Action", value: "action" },
        { text: "ID", value: "id" },
        { text: "Item Name", value: "item.item_name" },
        { text: "Quantity", value: "quantity" },
        { text: "Amount", value: "amount" },
        { text: "Transferred By", value: "user.full_name" },
        { text: "From Branch", value: "from_branch" },
        { text: "Transfer Date", value: "transfer_date" },
        { text: "Notes", value: "notes" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      item_transfers: "item_transfer/item_transfers",
      items: "item/items",
      all_items: "item/all_items",
      user: "auth/user",
    }),
    // Incoming transfers to the logged-in user's branch that haven't been
    // confirmed as received yet.
    pendingConfirmations() {
      let branchName =
        this.user && this.user.branch ? this.user.branch.branch_name : null;
      if (!branchName) return [];
      return this.item_transfers.filter(
        (t) => t.to_branch === branchName && !t.confirmed_received_at
      );
    },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("en-PH", {
        style: "currency",
        currency: "PHP",
      }).format(value);
    },
    formatDate(value) {
      if (!value) return "";
      return new Date(value).toLocaleDateString("en-PH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    canConfirm(item) {
      let branchName =
        this.user && this.user.branch ? this.user.branch.branch_name : null;
      return (
        branchName &&
        !item.is_reverted &&
        !item.confirmed_received_at &&
        item.to_branch === branchName
      );
    },
    async confirmReceived(item) {
      let confirmed = await this.$confirm({
        title: "Confirm Received",
        message: `Confirm that this transfer has physically arrived at your branch?<br><br>Item: ${
          item.item?.item_name || "N/A"
        }<br>Quantity: ${item.quantity}<br>From: ${item.from_branch}`,
        color: "green",
        icon: "mdi-check-circle",
      });

      if (!confirmed) return;

      this.confirmingId = item.id;
      try {
        await axios.put("/item_transfer/" + item.id + "/confirm_received");
        this.$alert({
          title: "Success",
          message: "Transfer confirmed as received",
          color: "success",
          icon: "mdi-check-circle",
        });
        // Refresh list and history so the confirmation shows up everywhere
        await this.get_item_transfers();
        await this.fetchTransferHistory();
      } catch (error) {
        console.error("Error confirming transfer:", error);
        this.$alert({
          title: "Error",
          message:
            "Failed to confirm transfer: " +
            (error.response?.data?.error || error.message),
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.confirmingId = null;
      }
    },
    async openDialog() {
      this.dialog = true;
      await this.fetchTransferHistory();
    },
    // Close the transfer form and refresh the history/list so a just-completed
    // transfer shows up immediately. (JMB-17)
    async onTransferModalClose() {
      this.show_item_transfer_modal = false;
      this.transfer_scanned_serials = [];
      await this.get_item_transfers();
      await this.fetchTransferHistory();
    },
    async fetchTransferHistory() {
      this.historyLoading = true;
      try {
        let response = await axios.get("/item_transfer_history");
        this.transferHistory = response.data;
      } catch (error) {
        console.error("Error fetching transfer history:", error);
      } finally {
        this.historyLoading = false;
      }
    },
    async confirmRevert(item) {
      let confirmed = await this.$confirm({
        title: "Revert Transfer",
        message: `Are you sure you want to revert this transfer?<br><br>Item: ${
          item.item?.item_name || "N/A"
        }<br>Quantity: ${item.quantity}<br>From: ${item.from_branch}<br>To: ${
          item.to_branch
        }<br><br>This will:<br>1. Delete the journal entries<br>2. Restore the item quantity to the source branch`,
        color: "orange",
        icon: "mdi-alert",
      });

      if (confirmed) {
        await this.revertTransfer(item);
      }
    },
    async revertTransfer(item) {
      this.revertingId = item.id;
      try {
        let response = await axios.delete("/delete_item_transfer/" + item.id);

        if (response.data.success) {
          this.$alert({
            title: "Success",
            message: "Item transfer reverted successfully",
            color: "success",
            icon: "mdi-check-circle",
          });
          // Refresh data
          await this.get_item_transfers();
          await this.fetchTransferHistory();
          // Refresh items list
          this.$store.dispatch("item/get_items");
        } else {
          this.$alert({
            title: "Error",
            message:
              "Failed to revert: " + (response.data.error || "Unknown error"),
            color: "error",
            icon: "mdi-alert-circle",
          });
        }
      } catch (error) {
        console.error("Error reverting transfer:", error);
        this.$alert({
          title: "Error",
          message:
            "Failed to revert transfer: " +
            (error.response?.data?.error || error.message),
          color: "error",
          icon: "mdi-alert-circle",
        });
      } finally {
        this.revertingId = null;
      }
    },
    ...mapActions({
      get_item_transfers: "item_transfer/get_item_transfers",
      get_all_items: "item/get_all_items",
    }),
    open_item_transfer(item, scannedSerials = []) {
      this.selected_item = item;
      this.transfer_scanned_serials = scannedSerials;
      this.show_item_transfer_modal = true;
    },
    openSerialScan() {
      this.serial_scan_input = "";
      this.serial_scan_feedback = "";
      this.scanned_serials = [];
      this.scanned_item = null;
      this.serial_scan_dialog = true;
      this.$nextTick(() => {
        setTimeout(() => {
          const f = this.$refs.serialScanField;
          if (f && f.focus) f.focus();
        }, 200);
      });
    },
    closeSerialScan() {
      this.serial_scan_dialog = false;
      this.scanned_serials = [];
      this.scanned_item = null;
    },
    removeScannedSerial(i) {
      this.scanned_serials.splice(i, 1);
      if (!this.scanned_serials.length) this.scanned_item = null;
    },
    focusSerialField() {
      this.$nextTick(() => {
        const f = this.$refs.serialScanField;
        if (f && f.focus) f.focus();
      });
    },
    // Scan a serial number to look up its in-stock item in this branch and queue
    // that specific serial for transfer. Multiple serials can be scanned; they
    // must all belong to the same item (one transfer = one item). (JMB-242)
    async scanSerialToTransfer() {
      const raw = (this.serial_scan_input || "").trim();
      if (!raw) return;
      this.serial_scan_loading = true;
      this.serial_scan_feedback = "";
      try {
        const res = await axios.get("/item_by_serial", {
          params: { serial: raw },
        });
        const foundItem = res.data.item;
        const serialNo = res.data.serial_number || raw.toUpperCase();

        // All scanned serials must belong to the same item.
        if (this.scanned_item && this.scanned_item.id !== foundItem.id) {
          this.serial_scan_feedback_type = "error";
          this.serial_scan_feedback = `Serial "${serialNo}" belongs to a different item (${foundItem.item_name}). Finish this transfer first.`;
          this.serial_scan_loading = false;
          this.serial_scan_input = "";
          this.focusSerialField();
          return;
        }
        // Reject duplicates.
        if (this.scanned_serials.some((s) => s.serial_number === serialNo)) {
          this.serial_scan_feedback_type = "error";
          this.serial_scan_feedback = `Serial "${serialNo}" is already scanned.`;
          this.serial_scan_loading = false;
          this.serial_scan_input = "";
          this.focusSerialField();
          return;
        }

        // Prefer the already-loaded item object so the table stays in sync.
        this.scanned_item =
          this.items.find((i) => i.id === foundItem.id) || foundItem;
        this.scanned_serials.push({
          serial_number: serialNo,
          serial_id: res.data.serial_id,
          lot_id: res.data.item_stock_lot_id,
          batch_description: res.data.batch_description,
        });
        this.serial_scan_feedback_type = "success";
        this.serial_scan_feedback = `Added "${serialNo}".`;
      } catch (e) {
        this.serial_scan_feedback_type = "error";
        if (e.response && e.response.status === 404) {
          this.serial_scan_feedback = `No in-stock item found for serial "${raw}".`;
        } else {
          this.serial_scan_feedback =
            (e.response && e.response.data && e.response.data.error) ||
            "Serial lookup failed. Please try again.";
        }
      }
      this.serial_scan_loading = false;
      this.serial_scan_input = "";
      this.focusSerialField();
    },
    // Hand the scanned serials to the transfer form (serial-driven mode).
    transferScannedSerials() {
      if (!this.scanned_serials.length || !this.scanned_item) return;
      const item = this.scanned_item;
      const serials = this.scanned_serials.slice();
      this.serial_scan_dialog = false;
      this.open_item_transfer(item, serials);
    },
  },
  created() {
    if (this.item_transfers.length <= 0) this.get_item_transfers();
    if (this.all_items.length <= 0) this.get_all_items();
  },
};
</script>

<style lang="scss" scoped></style>
